import { Button, Col, Container, Row } from "react-bootstrap";
import Poster1 from "../../image/cipra_pages/1.jpg";
import Poster2 from "../../image/cipra_pages/2.jpg";
import Poster3 from "../../image/cipra_pages/3.jpg";
import Doc from "../../docs/cipra2022_brochure.pdf";

export default function Cipra() {
    return <>
    <Container fluid>
        <Container>
            <br/>
            <img src={Poster1} width="100%"/>
            <img src={Poster2} width="100%"/>
            <img src={Poster3} width="100%"/>
            <br/><br/>
            <Row className="justify-content-center">
                    <Col md="auto" sm="12">
                        <Button href={Doc} target="_blank">Read Brochure <i className="bi bi-arrow-right"></i></Button>
                    </Col>
            </Row>
            <br/><br/>

        </Container>
    </Container>
    </>
}